export const language: any = {
  title: 'Bahan-bahan',
  select_all: 'Pilih semua',
  deselect_all: 'Batalkan pilihan semua',
  add: 'Tambah bahan',
  add_title: 'Silakan pilih cara untuk menambah bahan.',
  add_by_list: 'Tambah bahan',
  add_total: 'Tambah total {number} bahan',
  selecting: 'Total bahan',
  filter_title: 'Urutkan pilihan',
  filter_newest: 'Terbaru',
  filter_oldest: 'Paling lama',
  filter_alphabet: 'Urutkan abjad',
  get_recipe: 'Dapatkan rekomendasi masakan AI',
  search_placeholder: 'Silakan masukkan kata pencarian Anda.',
  nodata: 'Tidak ada bahan.',
  request: 'Tambah bahan',
  recipe_title: 'Hidangan yang Disarankan',
  option: {
    title: 'Pilih opsi',
    desc: 'Memilih opsi ini tidak wajib.',
    complete: 'Selesai',
    reset: 'Mengatur ulang',
  },
  msg: {
    msg_7: "Apakah Anda ingin menambahkan bahan yang dipilih?",
    msg_8: `
      <p>Apakah Anda ingin menambahkan bahan yang dipilih?</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> dikecualikan karena sudah termasuk dalam bahan makanan yang ada.)</p>
    `,
    msg_9: "Apakah Anda ingin menambahkan bahan yang dipilih ke keranjang belanja Anda?",
    msg_10: `
      <p>Apakah Anda ingin menambahkan bahan yang dipilih ke keranjang belanja Anda?<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> dikecualikan karena sudah termasuk dalam bahan makanan yang ada.)</p>
    `,
    confirm: 'Tambah',
    cancel: 'Batal',
    not_ingredient: 'Tampaknya yang Anda masukkan bukan bahan makanan.<br />Silakan periksa kembali.',
    ai_failed: 'Terjadi kesalahan saat memasukkan bahan makanan.<br />Silakan coba lagi.',
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span> dikecualikan karena sudah termasuk dalam bahan makanan yang ada.)`
  },
  history: "Riwayat analisis gambar",
  myIngredient: "Bahan saya",
  history_no_data: "Tidak ada riwayat",
  history_take_photo: "Ambil atau pilih foto",
}
